<template>
  <div style="height: 100%; width: 100%; display: flex; flex-direction: row; justify-content: flex-start;">
    <div style="display: flex; flex-direction: row; width: 100%;">
      <div v-if="optional" style=" display: flex; flex-direction: row;">
        <input
          style="align-self: center; margin-right: 2px;"
          type="checkbox"
          :id="`${identifier}-text-optionality`"
          name="`${identifier}-text-optionality`"
          v-model="isActive"
          @change="handleOptionality"
        >
      </div>
      <div style=" display: flex; flex-direction: row;">
        {{label}}<div style="display: inline-block;">:</div>
      </div>
      <input
        :disabled="optional && !isActive"
        type="text"
        style="border: 1px solid rgba(34,36,38,.15); border-radius: 0.35rem;"
        :style="`width: ${(value ? value.length : 0) + 2}ch;`"
        @blur="editing = false"
        v-if="editing"
        v-model="value"
        :identifier="`${identifier}-text`"
        @change="handleInput"
        />
      <div
        v-else-if="!editing"
        @click="editing = true"
        class="editable-input"
        :class="{'disabled' :!isActive}"
        :style="`width: ${(value ? value.length : 0) + 2}ch;`"
        >
        {{value}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormTextInput',
  props: {
    identifier: {
      required: true,
    },
    initialValue: {
      required: true,
    },
    label: String,
    optional: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      editing: false,
      value: undefined,
      isActive: undefined,
    }
  },
  methods: {
    handleInput (event) {
      this.value = event.target.value
      this.$emit('change', this.value)
    },
    handleOptionality (event) {
      if (!this.isActive) {
        this.value = undefined
        this.$emit('change', this.value)
      }
    },
  },
  computed: {
  },
  mounted () {
    if (this.optional) {
      this.isActive = this.initialValue != null
    }
    this.value = this.initialValue
  },
}
</script>

<style scoped>
.editable-input {
  padding-left: .5rem;
  padding-right: .5rem;
  cursor: pointer;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4.9px
}
.editable-input.disabled {
  background-color: rgba(239, 239, 239, 0.3);
}
</style>
